// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ingredientWrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 5px;
}

.deleteButton {
  color: white;
  background-color: rgb(179, 0, 0);
  border-radius: 3px;
}

.addButton {
  color: white;
  background-color: green;
  border-radius: 5px;
  width: 120px;
  height: 30px;
  /* Right align */
  margin-left: auto;
  margin-right: 0;
  display: block;
}

.scaleButton {
  background-color: rgb(158, 201, 190);
  border-width: 0px;
  border-radius: 5px;
  font-size: 14pt;
  padding: 4px 4px 4px 4px;
}
`, "",{"version":3,"sources":["webpack://./src/recipe-component/ingredients.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".ingredientWrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 5px;\n}\n\n.deleteButton {\n  color: white;\n  background-color: rgb(179, 0, 0);\n  border-radius: 3px;\n}\n\n.addButton {\n  color: white;\n  background-color: green;\n  border-radius: 5px;\n  width: 120px;\n  height: 30px;\n  /* Right align */\n  margin-left: auto;\n  margin-right: 0;\n  display: block;\n}\n\n.scaleButton {\n  background-color: rgb(158, 201, 190);\n  border-width: 0px;\n  border-radius: 5px;\n  font-size: 14pt;\n  padding: 4px 4px 4px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
